import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../../App.css';
import '../registerPage/registerPage.css';
import { forwardRef } from 'react';
import {END_URL} from '../../config';
import ProgressBar from '../submissions/progress.jsx';
import logoImg from '../../images/carter-logo.svg';

const FormField = forwardRef((props, ref) => (
  <div className="form-row">
    <label   dangerouslySetInnerHTML={{ __html: props.label }}></label>
    <input
      ref={ref}
      type={props.type}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      className="form-control"
      placeholder={props.placeholder}
      max={props.max}
    />
    {props.error && <p className="error-message new-error-found">{props.error}</p>}
  </div>
));


// Reusable radio button group
const RadioButtonGroup = ({ label, name, options, value, onChange, error }) => (
  <div className="form-row">
    <label>{label}</label>
    {options.map((option) => (
      <span key={option}>
        <input
          type="radio"
          name={name}
          value={option}
          onChange={onChange}
          checked={value === option}
        />{' '}
        {option}
      </span>
    ))}
      {error && <p className="error-message new-error-found">{error}</p>}
  </div>
);

const SelectField = ({ label, name, options, value, onChange , error}) => (
  <div className="form-row">
    <label>{label}</label>
    <select name={name} value={value} onChange={onChange} className="form-control">
      <option value="">Please Select</option>
      {options && options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </select>
     {error && <p className="error-message new-error-found">{error}</p>}
  </div>
);



function RegisterPage() {
  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    postalcode: '',
    country_id: '',
    dob: '',
    occupation: '',
    supermarket_used: '',
    primary_shopper: '',
    shopping_frequency: '',
    household_people: '',
    store_location: '',
    average_spend: '',
    sale_price_usage: '',
    pricing_awareness: '',
    heard_about: '',
    preferred_contact: [],
    consent: '',
    other_specify:'',
  });

  const [message, setMessage] = useState('');

  const [submitDone, setsubmitDone] = useState(false);

  const [errors, setErrors] = useState({});
  const [countries, setCountries] = useState([]);

  const [states, setstates] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dynamicContent, setDynamicContent] = useState(null);

  const [FormStep, setFormStep] = useState(1);

  const [Forward, setForward] = useState(1);

  const refs = useRef({}); 

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${END_URL}countries`);

        if (response.data && response.data.countries && Array.isArray(response.data.countries)) {
          const countryNames = response.data.countries.map((country_id) => country_id.name.common).sort((a, b) => a.localeCompare(b));

          console.log(response.data.countries
            ,'yrtyr');

          setCountries(response.data.countries);
        } else {
          console.error('Data is not in the expected format:', response.data);
    
          setCountries([]);
        }
      } catch (error) {
        console.error('Failed to fetch countries:', error);
      }
    };

    fetchCountries();
  }, []);


    const fetchStates = async (country_id) => {

      try {
        if (country_id) { 
          const response = await axios.get(`${END_URL}states/${country_id}`);

          if (response.data && Array.isArray(response.data.states)) {
            setstates(response.data.states);
          } else {
            setstates([]);
          }
        } else {
          setstates([]);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
        setstates([]);
      }
    };




useEffect(() => {
  const fetchDynamicContent = async () => {
    try {
      const response = await axios.get(`${END_URL}dynamic-page`);
      setDynamicContent(response.data.data); // Assuming your API returns { data: ... }
    } catch (error) {
      console.error('Failed to fetch dynamic content:', error);
    }
  };

  fetchDynamicContent();
}, []);

  useEffect(() => {
    
    if(FormStep > Forward){
      setForward(FormStep);
    }

  }, [FormStep]);


  const handleChange = (e) => {
    const { name, value } = e.target;

      if (name === "phone" || name === "postalcode") {
        // Allow only digits in phone and postalcode fields
        const numericValue = value.replace(/\D/g, "");
        setFormData((prevData) => ({ ...prevData, [name]: numericValue }));
      } else {
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      }
      if (name === "country_id") {

        setFormData((prevData) => ({ ...prevData, state: "" }));

        fetchStates(value);
      }
  };
  
      const handleCheckboxChange = (e) => {

        const { value, checked } = e.target;

        setFormData((prev) => {
          
          let updatedList = Array.isArray(prev.heard_about) ? [...prev.heard_about] : [];

          if (checked) {
            updatedList.push(value);
          } else {
            updatedList = updatedList.filter((item) => item !== value);
          }

          return {
            ...prev,
            heard_about: updatedList,
          };
        });
      };

    const handlePreferredContactChange = (e) => {

      const { value, checked } = e.target;

      setFormData((prev) => {
        let updatedList = Array.isArray(prev.preferred_contact)
          ? [...prev.preferred_contact]
          : [];

        if (checked) {
          updatedList.push(value);
        } else {
          updatedList = updatedList.filter((item) => item !== value);
        }

        return {
          ...prev,
          preferred_contact: updatedList,
        };
      });
    };

//   const validateForm = () => {
//     const errors = {};

//     if (!formData.name) {
//       errors.name = 'First Name is required';
//     } else if (formData.name.length < 2) {
//       errors.name = 'Name must be at least 2 characters long';
//     }


  

//    if (!formData.email) {

//       errors.email = 'Email is required';

//     } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)) {

//       errors.email = 'Invalid email address';

//     }
  

//     if (!formData.phone) {
//         errors.phone = 'phone number is required';
//       }

//     if (!formData.address) {
//       errors.address = 'Address is required';
//     }

   
//     if (!formData.city) {
//       errors.city = 'city is required';
//     }

//     if (!formData.state) {
//       errors.state = 'state is required';
//     }

//     if (!formData.postalcode) {
//       errors.postalcode = 'postalcode is required';
//     }

//     if (!formData.country_id) {
//       errors.country_id = 'country is required';
//     }

//     if (!formData.dob) {
//       errors.dob = 'Date of birth is required';
//     }
//     if (!formData.supermarket_used) {
//       errors.supermarket_used = 'Please select a supermarket';
//     }

//     if (!formData.sale_price_usage) {
//       errors.sale_price_usage = 'Please select an option for sale price usage';
//     }

//     if (!formData.pricing_awareness) {
//       errors.pricing_awareness = 'Please select an option for pricing awareness';
//     } else if (!['Yes', 'No'].includes(formData.pricing_awareness)) {
//       errors.pricing_awareness = 'Invalid option selected';
//     }

// if (!formData.average_spend) {
//     errors.average_spend = 'Please enter average spend';
//   }
  
// if (!formData.consent) {
//   errors.consent = 'You must consent to proceed';
// }

//     return errors;
//   };

  // Validate Step 1
  const validateStep1 = () => {
    const errors = {};

    if (!formData.name) {
      errors.name = 'First Name is required';
    } else if (formData.name.length < 2) {
      errors.name = 'Name must be at least 2 characters long';
    }
    if (!formData.lastname) {

      errors.lastname = 'Last Name is required';
    }

    if (!formData.email) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)) {
      errors.email = 'Invalid email address';
    }

    if (!formData.phone) {
      errors.phone = 'Phone number is required';
    }

    // if (!formData.dob) {
    //   errors.dob = 'Date of birth is required';
    // }

    return errors;
  };

  // Validate Step 2
  const validateStep2 = () => {
    const errors = {};

    // if (!formData.address) {
    //   errors.address = 'Address is required';
    // }

    // if (!formData.city) {
    //   errors.city = 'City is required';
    // }

    if (!formData.state) {
      errors.state = 'State is required';
    }

    // if (!formData.postalcode) {
    //   errors.postalcode = 'Postal code is required';
    // }

    // if (!formData.country_id) {
    //   errors.country_id = 'Country is required';
    // }

    return errors;
  };

  // Validate Step 3
  const validateStep3 = () => {
    const errors = {};

    if (!formData.supermarket_used) {
      errors.supermarket_used = 'Please select if you shopped at Woolworths';
    }

    // if (!formData.average_spend) {
    //   errors.average_spend = 'Please enter average spend';
    // }

    // if (!formData.sale_price_usage) {
    //   errors.sale_price_usage = 'Please select an option for sale price usage';
    // }

    // if (!formData.pricing_awareness) {
    //   errors.pricing_awareness = 'Please select an option for pricing awareness';
    // }

    return errors;
  };

  // Validate Step 4
  const validateStep4 = () => {
    const errors = {};

    if (!formData.consent) {
      errors.consent = 'You must consent to proceed';
    }

    return errors;
  };


  const handleStepContinue = () => {
      let validationErrors = {};

      if (FormStep === 1) {
        validationErrors = validateStep1();
      } else if (FormStep === 2) {
        validationErrors = validateStep2();
      } else if (FormStep === 3) {
        validationErrors = validateStep3();
      }

      setErrors(validationErrors);

      if (Object.keys(validationErrors).length > 0) {
        scrollToErrorField(validationErrors);
      } else {
       
        setErrors({});
        setFormStep((prevStep) => prevStep + 1);
      }
    };

    
  const scrollToErrorField = (errors) => {
    for (const key in errors) {
      if (refs.current[key]) {
        refs.current[key].scrollIntoView({ behavior: 'smooth', block: 'center' });
        break; 
      }
    }
  };


  const handleSubmit = async (e) => {

      e.preventDefault();

      const step4Errors = validateStep4();
      setErrors(step4Errors);

      if (Object.keys(step4Errors).length > 0) {
        scrollToErrorField(step4Errors);
        return;
      }

      const allErrors = {
        ...validateStep1(),
        ...validateStep2(),
        ...validateStep3(),
        ...validateStep4(),
      };

      if (Object.keys(allErrors).length > 0) {
        setErrors(allErrors);
        setMessage('Please check all steps for errors');
        scrollToErrorField(allErrors);
        return;
      }

      setLoading(true);

      try {
          const response = await axios.post(
            `${END_URL}signup`,
            formData,
            {
              headers: { 'Content-Type': 'application/json' },
            }
          );
    
          if (response.status === 200 || response.status === 201) {

            setMessage('Registration successful! Please check your email to set your password.');

            setsubmitDone(true);

            setFormData({
              name: '',
              lastname: '',
              email: '',
              phone: '',
              address: '',
              city: '',
              state: '',
              postalcode: '',
              country_id: '',
              dob: '',
              occupation: '',
              supermarket_used: '',
              primary_shopper: '',
              shopping_frequency: '',
              household_people: '',
              store_location: '',
              average_spend: '',
              sale_price_usage: '',
              pricing_awareness: '',
              heard_about: [],
              preferred_contact: '',
              other_specify:'',
            });
          } else {
            setMessage('Failed to submit form. Please try again.');
          }
        } catch (error) {
          if (error.response && error.response.data) {
            const { message, errors } = error.response.data;
            if (errors) {
              setErrors(errors);
            }
            setMessage(message);
          } else {
            console.error('Error submitting form:', error);
            setMessage('Error submitting form.');
          }
        }
        finally {
          setLoading(false);  
        }
    
    };
  // const handleSubmit = async (e) => {

  //   e.preventDefault();
  
  //   const validationErrors = validateForm();

  //   console.log(validationErrors,'validationErrors');

  //   setErrors(validationErrors);
  
  //   if (Object.keys(validationErrors).length > 0) {
  //     scrollToErrorField(validationErrors);
  //   } else {
  //     setLoading(true);
  //     try {
  //       const response = await axios.post(
  //         `${END_URL}signup`,
  //         formData,
  //         {
  //           headers: { 'Content-Type': 'application/json' },
  //         }
  //       );
  
  //       if (response.status === 200 || response.status === 201) {
  //         setMessage('Registration successful! Please check your email to set your password.');
  //         setFormData({
  //           name: '',
  //           lastname: '',
  //           email: '',
  //           phone: '',
  //           address: '',
  //           city: '',
  //           state: '',
  //           postalcode: '',
  //           country_id: '',
  //           dob: '',
  //           occupation: '',
  //           supermarket_used: '',
  //           primary_shopper: '',
  //           shopping_frequency: '',
  //           household_people: '',
  //           store_location: '',
  //           average_spend: '',
  //           sale_price_usage: '',
  //           pricing_awareness: '',
  //           heard_about: '',
  //           preferred_contact: '',
  //         });
  //       } else {
  //         setMessage('Failed to submit form. Please try again.');
  //       }
  //     } catch (error) {
  //       if (error.response && error.response.data) {
  //         const { message, errors } = error.response.data;
  //         if (errors) {
  //           setErrors(errors);
  //         }
  //         setMessage(message);
  //       } else {
  //         console.error('Error submitting form:', error);
  //         setMessage('Error submitting form.');
  //       }
  //     }
  //     finally {
  //       setLoading(false);  
  //     }
  //   }
  // };

  const todayDate = new Date().toISOString().split('T')[0];
  

  return (
    <section className="register-wrapp">
      <div className="register-row">
        <div className="register-sidebar">

          <div className="logo" onClick={() => window.location.href = '/'}>

            <img src={logoImg} alt="" />

          </div>

          <div className="stats">
            <strong>Current status:</strong>
             {dynamicContent?.currentstatustext}
          </div>
          <div className="sidecard" dangerouslySetInnerHTML={{ __html:dynamicContent?.registercontent2 }} />

          <div className="sidecard">
            <h3>Your progress</h3>
            <div className="page-wrapp">
              <div className="prg-container"  style={FormStep == 1 ? { width: "0%" } : FormStep == 2 ? { width: "33%" } : FormStep == 3 ? { width: "66%" } : FormStep == 4 ? { width: "100%" } : { width: "0%" } }>
                <ProgressBar progress={{width:"60%"}} />
            </div>
            </div>
                <div className="steps">
                  <ol>
                    <li>Personal</li>
                    <li>Address</li>
                    <li>Shopping</li>
                    <li>Consent</li>
                  </ol>
                </div>
          </div>
          <div className="chipcard">
            <div className="chip">Court‑supervised</div>
            <div className="chip">Privacy‑first</div>
            <div className="chip">No cost to register</div>
          </div>
          <div className="sidecard contact">
            <h3>Need help?</h3>
            <p>Questions or trouble with the form?</p>
            <ul>
              <li><a href="">Contact our team</a></li>
              <li><a href="">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="register-box">
          <div className="register-col1">
           <div dangerouslySetInnerHTML={{ __html: dynamicContent?.registercontent1 }} />
           <div className="page-wrapp">
           <div className="prg-container" style={FormStep == 1 ? { width: "0%" } : FormStep == 2 ? { width: "33%" } : FormStep == 3 ? { width: "66%" } : FormStep == 4 ? { width: "100%" } : { width: "0%" } } >
              <ProgressBar progress={{width:"20%"}} />
            </div>
            </div>
          </div>

        {!submitDone && (

            <div className="steps">
              <ol>
                <li className={FormStep > 1 ? 'green_flag' : '' || FormStep == 1 ? 'active' : ''} onClick={() => setFormStep(1)} >Personal</li>

                <li className={FormStep > 2 ? 'green_flag' : '' || FormStep == 2 ? 'active' : ''} onClick={() => {if (Forward >= 2) setFormStep(2); }} >Address</li>

                <li className={FormStep > 3 ? 'green_flag' : '' || FormStep == 3 ? 'active' : ''} onClick={() => {if (Forward >= 3) setFormStep(3); }}  >Shopping</li>
                <li className={FormStep == 4 ? 'active' : ''} onClick={() => {if (Forward ==4) setFormStep(4); }} >Consent</li>
              </ol>
            </div>

        )}

        {!submitDone ? (

          <div className="register-col2">

            <form onSubmit={handleSubmit}>

            {FormStep === 1 && (
                <>
                <h3>Step 1: Personal Details</h3>

                <div className="register-row1 personal-details">
                  
                      <FormField
                        ref={(el) => (refs.current.name = el)}
                        label={`First Name <sub>*</sub>`}
                        name="name"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder=""
                        error={errors.name}

                      />
                    
                      <FormField
                        label={`Last Name <sub>*</sub>`}
                        name="lastname"
                        type="text"
                        value={formData.lastname}
                        onChange={handleChange}
                        placeholder=""
                        error={errors.lastname}
                    />

                  
                    <FormField
                      ref={(el) => (refs.current.email = el)}
                      label={`Email <sub>*</sub>`}
                      name="email"
                      type="text"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      error={errors.email}
                    />
                    
                    

                      <FormField
                      ref={(el) => (refs.current.phone = el)}
                        label={`Phone <sub>*</sub>`}
                        name="phone"
                        type="text"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="e.g., 04xx xxx xxx or 07 xxxx xxxx"
                        error={errors.phone}
                      />

                    <FormField
                      ref={(el) => (refs.current.dob = el)}
                      label="Date of Birth"
                      name="dob"
                      type="date"
                      value={formData.dob}
                      onChange={handleChange}
                      placeholder=""
                      max={todayDate}
                      error={errors.dob}
                    />

                    <FormField
                      label="Occupation"
                      name="occupation"
                      type="text"
                      value={formData.occupation}
                      onChange={handleChange}
                      placeholder=""
                    />
                  
              </div>

                  <div className="button-cta">
                  <input 
                      type="button" 
                      value="Continue" 
                      className="reg-btn" 
                      onClick={handleStepContinue}
                  />
                  </div>
                
              </>
            )}

            {FormStep === 2 && (

              <>

                <h3>Step 2: Address Details</h3>

                <div className="register-row1 address-details">
                    <FormField
                        ref={(el) => (refs.current.address = el)}
                        label="Street Address"
                        name="address"
                        type="text"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder=""
                        error={errors.address}
                      />
                  
                    <FormField
                      label="City / Suburb"
                      name="city"
                      type="text"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder=""
                      error={errors.city}
                    />

                    {/* <FormField
                      label="State / Territory"
                      name="state"
                      type="text"
                      value={formData.state}
                      onChange={handleChange}
                      placeholder="State / Territory"
                      error={errors.state}
                    /> */}

                    <SelectField
                      label="Country"
                      name="country_id"
                      options={countries}
                      value={formData.country_id}
                      onChange={handleChange}
                      error={errors.country_id}
                    />

                    <SelectField
                      label="State / Territory"
                      name="state"
                      options={states}
                      value={formData.state}
                      onChange={handleChange}
                      error={errors.state}
                    />

                    <FormField
                      label="Postal Code"
                      name="postalcode"
                      type="text"
                      value={formData.postalcode}
                      onChange={handleChange}
                      placeholder="4 digits"
                      error={errors.postalcode}
                    />

                </div>

                      <div className="button-cta">

                      
                  <input type="button" value="Back" className="reg-btn reg-back" onClick={() => setFormStep(prevStep => prevStep - 1)} />

                    <input 
                        type="button" 
                        value="Continue" 
                        className="reg-btn" 
                       onClick={handleStepContinue}
                    />
                    </div>

                </>
              )}

            {FormStep === 3 && (

              <>

              <h3>Step 3: Woolworths Shopping Details</h3>

              <div className="register-row1  shopping-details">

                    {/* <div className="form-row">
                      <label>Supermarket(s) used</label>
                      {['coles'].map((option) => (
                        <span key={option}>
                          <input
                            type="radio"
                            name="supermarket_used"
                            value={option}
                            onChange={handleChange}
                            checked={formData.supermarket_used === option}
                          />{' '}
                          {option}
                        </span>
                      ))}
                      {errors.supermarket_used && <p className="error-message new-error-found">{errors.supermarket_used}</p>}
                    </div> */}

                    <div className="form-row">
                      <label>Did you shop at Woolworths between Sep 2021 and May 2023? <sub>*</sub></label>
                      {['Yes','No'].map((option) => (
                        <span key={option}>
                          <input
                            type="radio"
                            name="supermarket_used"
                            value={option}
                            onChange={handleChange}
                            checked={formData.supermarket_used === option}
                          />{' '}
                          {option}
                        </span>
                      ))}
                      {errors.supermarket_used && <p className="error-message new-error-found">{errors.supermarket_used}</p>}
                    </div>

                      <div className="form-row">
                        <label>Were you the primary household shopper for Woolworths during this period?</label>
                        {['Yes', 'No'].map((option) => (
                          <span key={option}>
                            <input
                              type="radio"
                              name="primary_shopper"
                              value={option}
                              onChange={handleChange}
                              checked={formData.primary_shopper === option}
                            />{' '}
                            {option}
                          </span>
                        ))}
                      </div>


                      <FormField
                        label="Household size"
                        name="household_people"
                        type="number"
                        value={formData.household_people}
                        onChange={handleChange}
                        placeholder="e.g., 3"
                        error={errors.household_people}
                      />

                      <span className="form-note">How many people you usually shopped for at Woolworths.</span>

                      <FormField
                          label="Typical Woolworths shop spend (A$)"
                          name="average_spend"
                          type="number"
                          value={formData.average_spend}
                          onChange={handleChange}
                          placeholder="e.g., 150"
                          error={errors.average_spend}
                      />

                      <span className="form-note">Whole dollars only, no $ sign or cents.</span>

                      <FormField
                          label="Main Woolworths store & suburb"
                          name="store_location"
                          type="text"
                          value={formData.store_location}
                          onChange={handleChange}
                          placeholder="e.g., Woolworths Mudgeeraba, QLD 4213"
                          error={errors.store_location}
                      />

                      <span className="form-note">{"Prefer Woolworths <Suburb>, STATE POSTCODE” rather than an intersection."}</span>

                      <div className="form-row">
                        <label>How often did you shop at Woolworths during the claim period?</label>
                          <select
                            name="shopping_frequency"
                            value={formData.shopping_frequency}
                            onChange={handleChange}
                            className="form-control"
                          >
                            <option value="">Please Select</option>
                            <option value="More than twice a week">More than twice a week</option>
                            <option value="Twice a week">Twice a week</option>
                            <option value="Once a week">Once a week</option>
                            <option value="Every two weeks">Every two weeks</option>
                            <option value="Less frequently">Less frequently</option>
                          </select>
                      </div>


                      {/* <div className="form-row">
                        <label>Frequency of grocery shopping</label>
                        <select
                          name="shopping_frequency"
                          value={formData.shopping_frequency}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="">Please Select</option>
                          <option value="More than twice a week">More than twice a week</option>
                          <option value="Twice a week">Twice a week</option>
                          <option value="Once a week">Once a week</option>
                          <option value="Every two weeks">Every two weeks</option>
                          <option value="Less frequently than every two weeks">Less frequently than every two weeks</option>
                        </select>
                      </div> */}

                      {/* {[
                        {
                          label: 'Number of people in household?',
                          name: 'household_people',
                          type: 'text',
                        },
                        { label: 'Store location & suburb', name: 'store_location', type: 'text' },
                        {
                          label: 'Average spend per grocery shop?',
                          name: 'average_spend',
                          type: 'text',
                        },
                      ].map(({ label, name, type }) => (
                        <FormField
                          key={name}
                          label={label}
                          name={name}
                          type={type}
                          value={formData[name]}
                          onChange={handleChange}
                          placeholder={label}
                          error={errors[name]} 
                          
                        />
                      ))} */}
                      {/* {errors.average_spend && (
                        <p className="error-message new-error-found">{errors.average_spend}</p>
                      )} */}

                      {/* <div className="form-row">
                        <label>Do you typically take advantage of sale prices?</label>
                        {['Yes', 'No'].map((option) => (
                          <span key={option}>
                            <input
                              type="radio"
                              name="sale_price_usage"
                              value={option}
                              onChange={handleChange}
                              checked={formData.sale_price_usage === option}
                            />{' '}
                            {option}
                          </span>
                        ))}
                          {errors.sale_price_usage && (
                          <p className="error-message new-error-found">{errors.sale_price_usage}</p>
                        )}
                      </div> */}

                      <div className="form-row">
                        <label>Did you usually buy items because they were on Woolworths promotion (e.g., “Down Down”, “Prices Dropped”)?</label>
                        {['Yes', 'No'].map((option) => (
                          <span key={option}>
                            <input
                              type="radio"
                              name="sale_price_usage"
                              value={option}
                              onChange={handleChange}
                              checked={formData.sale_price_usage === option}
                            />{' '}
                            {option}
                          </span>
                        ))}
                          {errors.sale_price_usage && (
                          <p className="error-message new-error-found">{errors.sale_price_usage}</p>
                        )}
                      </div>
                      
                      {/* <div className="form-row">
                        <label>Awareness of alleged pricing issue before this class action?</label>
                        {['Yes', 'No'].map((option) => (
                          <span key={option}>
                            <input
                              type="radio"
                              name="pricing_awareness"
                              value={option}
                              onChange={handleChange}
                              checked={formData.pricing_awareness === option}
                            />{' '}
                            {option}
                          </span>
                        ))}
                        {errors.pricing_awareness && (
                        <p className="error-message new-error-found">{errors.pricing_awareness}</p>
                      )}
                      </div> */}
                           
                      <div className="form-row">
                        <label>Before this action, were you aware of concerns about Woolworths pricing practices?</label>
                        {['Yes', 'No'].map((option) => (
                          <span key={option}>
                            <input
                              type="radio"
                              name="pricing_awareness"
                              value={option}
                              onChange={handleChange}
                              checked={formData.pricing_awareness === option}
                            />{' '}
                            {option}
                          </span>
                        ))}
                        {errors.pricing_awareness && (
                        <p className="error-message new-error-found">{errors.pricing_awareness}</p>
                      )}
                      </div>
              </div>

              <div className="button-cta">
                          <input type="button" value="Back" className="reg-btn reg-back" onClick={() => setFormStep(prevStep => prevStep - 1)} />

                  <input 
                      type="button" 
                      value="Continue" 
                      className="reg-btn" 
                      onClick={handleStepContinue}
                  />
              </div>


                </>

            )}

            {FormStep === 4 && (

              <>

              <h3>Step 4: Consent & Review</h3>

                <div className="register-row1 consent-section">

                      <div className="form-row">

                        <label>How did you hear about this class action?</label>
                          {[
                            "News/Media",
                            "Social Media",
                            "Word of Mouth",
                            "Other"
                          ].map((option) => (
                            <span key={option} className="checkbox-item">
                              <input
                                type="checkbox"
                                name="heard_about"
                                value={option}
                                checked={
                                  formData.heard_about != null && Array.isArray(formData.heard_about) &&
                                  formData.heard_about.includes(option)
                                }
                                onChange={handleCheckboxChange}
                              />
                              {option}
                            </span>
                          ))}

                      </div>
                      

                       {formData?.heard_about?.includes("Other") && (

                        <FormField
                            label="Other (Please Specify)"
                            name="other_specify"
                            type="text"
                            value={formData.other_specify}
                            onChange={handleChange}
                            placeholder=""
                            error={errors.other_specify}
                        />

                      )}

                      <div className="form-row">

                        <label>Preferred contact method</label>
                          {["Email", "Phone", "Either"].map((option) => (
                            <span key={option} className="checkbox-item">
                              <input
                                type="checkbox"
                                name="preferred_contact"
                                value={option}
                                checked={
                                  Array.isArray(formData?.preferred_contact) &&
                                  formData?.preferred_contact?.includes(option)
                                }
                                onChange={handlePreferredContactChange}
                              />
                              {option}
                            </span>
                          ))}

                      </div>

                      <div className="form-group allshow-details">
                          <h3 className="preview-title">Please review your details before submitting</h3>

                          <div className="preview-grid">
                            <div className="preview-row">
                              <div className="preview-label">First Name</div>
                              <div className="preview-value">{formData.name || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">Last Name</div>
                              <div className="preview-value">{formData.lastname || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">Email</div>
                              <div className="preview-value">{formData.email || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">Phone</div>
                              <div className="preview-value">{formData.phone || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">Date of Birth</div>
                              <div className="preview-value">{formData.dob || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">Occupation</div>
                              <div className="preview-value">{formData.occupation || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">Street Address</div>
                              <div className="preview-value">{formData.address || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">City / Suburb</div>
                              <div className="preview-value">{formData.city || "—"}</div>
                            </div>
                           
                            <div className="preview-row">
                              <div className="preview-label">State / Territory</div>
                              <div className="preview-value">{states.find((item) => item.id == formData.state)?.name  || "—"}</div>
                            </div>

                            <div className="preview-row">
                              <div className="preview-label">Postal Code</div>
                              <div className="preview-value">{formData.postalcode || "—"}</div>
                            </div>
                            <div className="preview-row">
                              <div className="preview-label">Country</div>
                              <div className="preview-value"> {countries.find((item) => item.id == formData.country_id)?.name  || "—"}</div>
                            </div>
                           

                            <div className="preview-row">
                              <div className="preview-label">Did you shop at Woolworths between Sep 2021 and May 2023?</div>
                              <div className="preview-value">{formData.supermarket_used || "—"}</div>
                            </div>

                            <div className="preview-row">
                              <div className="preview-label">Household size</div>
                              <div className="preview-value">{formData.household_people || "—"}</div>
                            </div>

                            {/* <div className="preview-row">
                              <div className="preview-label">Primary Shopper</div>
                              <div className="preview-value">{formData.primary_shopper || "—"}</div>
                            </div> */}

                            <div className="preview-row">
                              <div className="preview-label">Typical Woolworths shop spend (A$)</div>
                              <div className="preview-value">{formData.average_spend || "—"}</div>
                            </div>

                            <div className="preview-row">
                              <div className="preview-label">Main Woolworths store & suburb</div>
                              <div className="preview-value">{formData.store_location || "—"}</div>
                            </div>

                            {/* <div className="preview-row">
                              <div className="preview-label">How often did you shop at Coles during the claim period?</div>
                              <div className="preview-value">{formData.shopping_frequency || "—"}</div>
                            </div> */}

                            <div className="preview-row">
                              <div className="preview-label">How often did you shop at Woolworths during the claim period?</div>
                              <div className="preview-value">{formData.shopping_frequency || "—"}</div>
                            </div>
                          
                            <div className="preview-row">
                              <div className="preview-label">Did you usually buy items because they were on Woolworths promotion (e.g., “Down Down”, “Prices Dropped”)?</div>
                              <div className="preview-value">{formData.sale_price_usage || "—"}</div>
                            </div>

                            {/* <div className="preview-row">
                              <div className="preview-label">Pricing Awareness</div>
                              <div className="preview-value">{formData.pricing_awareness || "—"}</div>
                            </div> */}

                            <div className="preview-row">
                              <div className="preview-label">How did you hear about this class action?</div>
                              <div className="preview-value">{(Array.isArray(formData.heard_about) ? formData.heard_about.join(', ') : formData.heard_about) || "—" }</div>
                            </div>

                            {/* <div className="preview-row">
                              <div className="preview-label">Preferred Contact</div>
                              <div className="preview-value">{formData.preferred_contact || "—"}</div>
                            </div> */}

                          </div>

                        </div>


                     <div className="form-group">
                        <label>
                          <input
                            type="checkbox"
                            name="consent"
                            checked={formData.consent || false}
                            onChange={(e) =>
                              handleChange({ target: { name: 'consent', value: e.target.checked } })
                            }
                          />
                          I confirm the above details are correct and consent to the <a href="/privacy" target="_blank" rel="noopener">Privacy Policy</a>
                        </label>

                          {errors.consent && <p className="text-red-500 constent-error">{errors.consent}</p>}
                      </div>

                      <div className="button-cta">

                      <input type="button" value="Back" className="reg-btn reg-back" onClick={() => setFormStep(prevStep => prevStep - 1)} />

                      <input type="submit" value={!loading ? 'Submit' : 'Submitting...'} className="reg-btn" disabled={loading} />

                        </div>

                    {message && <p className="form-message">{message}</p>}
                
                </div>

                </>
              )}
              
            </form>
          </div>

        ):(
            <div id="success" class="success-message">

              <div class="icon">✅</div>

              <h2>Registration Received</h2>

              <p>Thank you. We’ve received your Expression of Interest. A confirmation email will follow with next steps.</p>

              <a href="/" class="btn btn--primary">Return to Homepage</a>
              
            </div>
        )}

        </div>
      </div>
    </section>
  );
}

export default RegisterPage;
